import { searchItemView } from './utils'

export function drag(
  definition,
  absolutePoint,
  itemViews,
  interaction,
  methods,
) {
  itemViews.forEach(e => {
    e.type = 'default'
  })

  //search selected itemView
  const currentItemView = searchItemView(
    itemViews,
    definition.draggableEntities,
    definition.hitDetection,
    absolutePoint,
  )
  if (!currentItemView) return null
  currentItemView.type = 'dragging'

  //set history item
  methods.setHistory({
    type: 'drag',
    itemView: currentItemView,
    prevValue: { ...currentItemView.boundary },
  })

  //stop checking of interations
  return {
    currentItemView,
    status: 'drag',
    resizeOptions: {
      startX: absolutePoint.x,
      startY: absolutePoint.y,
    },
  }
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseDown/drag.js